import {ICategoryV2} from "@/app/dashboard/models/EventCategory";
import {ILocationV2} from "@/app/dashboard/models/Location";
import {IOrganization} from "./Organization";

export interface IEventsResponse {
    events: IEventResponse[];
}

interface IEventResponse {
    DateTime: string;
    Description: string;
    EndTime: string;
    EntryRequirement: string | null;
    EventID: string;
    Name: string;
    cheapest_ticket_price: number;
    image_url: string | null;
    location: ILocationResponse;
    organizer: IOrganizerResponse;
}

interface ILocationResponse {
    Address: string;
    Capacity: number;
    LocationID: string;
    Name: string;
    direction_url: string | null;
    latitude: string | null;
    longitude: string | null;
}

interface IOrganizerResponse {
    ContactInfo: string;
    Name: string;
    OrganizerID: string;
}

export interface IEvents {
    events: IEvent[];
}

export interface IEvent {
    dateTime: string;
    description: string;
    endTime: string;
    entryRequirement: string | null;
    eventID: string;
    name: string;
    cheapestTicketPrice: number;
    imageUrl: string | null;
    location: ILocation;
    organizer: IOrganizer;
}

interface ILocation {
    address: string;
    capacity: number;
    locationID: string;
    name: string;
    directionUrl: string | null;
    latitude: string | null;
    longitude: string | null;
}

interface IOrganizer {
    contactInfo: string;
    name: string;
    organizerID: string;
}

function convertEvent(event: IEventResponse): IEvent {
    return {
        dateTime: event.DateTime,
        description: event.Description,
        endTime: event.EndTime,
        entryRequirement: event.EntryRequirement,
        eventID: event.EventID,
        name: event.Name,
        cheapestTicketPrice: event.cheapest_ticket_price,
        imageUrl: event.image_url,
        location: convertLocation(event.location),
        organizer: convertOrganizer(event.organizer),
    };
}

function convertLocation(location: ILocationResponse): ILocation {
    return {
        address: location.Address,
        capacity: location.Capacity,
        locationID: location.LocationID,
        name: location.Name,
        directionUrl: location.direction_url,
        latitude: location.latitude,
        longitude: location.longitude,
    };
}

function convertOrganizer(organizer: IOrganizerResponse): IOrganizer {
    return {
        contactInfo: organizer.ContactInfo,
        name: organizer.Name,
        organizerID: organizer.OrganizerID,
    };
}

export function convertEventsResponse(response: IEventsResponse): IEvents {
    return {
        events: response.events.map(convertEvent),
    };
}

export function formatDateTime(dateTimeString: string): string {
    const date = new Date(dateTimeString);
    const options: Intl.DateTimeFormatOptions = {
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
    };
    return date.toLocaleString("en-US", options);
}

// New Models.....

export interface IEventV2 {
    id: string;
    name: string;
    image: string;
    eventImages?: string[];
    allowResale: boolean;
    startTimeStamp: string;
    endTimeStamp: number;
    description: string;
    htmlDescription: string;
    status: string;
    category: ICategoryV2;
    location: ILocationV2;
    organization: IOrganization;
    minTicketPrice: number;
    maxTicketPrice: number;
    hostedEventCount: number;
    durationMessage: string;
    createdAt: string;
    updatedAt: string;
    transactionFee: string;
    displayPriority: number;
    upcomingEvents?: IEventV2[];
    isTicketSalesClosed?: boolean;
    maxTicketLimit: number
    isSeatingPublished?: boolean;
    seatingImage?: string
}

export interface ICreateEvent extends IEventV2 {
    startTime: string;
    endTime: string;
    locationId: string;
    categoryId: string;
}

export enum EventStatus {
    Published = "PUBLISHED",
    Draft = "DRAFT",
    SoldOut = "SOLD_OUT",
    Blocked = "BLOCKED",
    PendingAccept = "PENDING_ACCEPT",
    PublishedAsPrivate = "PUBLISHED_AS_PRIVATE",
}
